import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {formatUnitCounters} from 'utils/formatUnitCounters'

export const MinimizedGuests = () => {
  const unitCounters = InputProvider.useUnitCounters('optional')
  const units = VentrataDataProvider.useUnits('optional')

  return <div>{formatUnitCounters(unitCounters, units)}</div>
}
